<template>
    <div class="energySliderContainer" ref="energyRef" :class="{good:good, bad:bad}">

        <div class="button-holder">
            <button class="goodButton">{{values.topTitle}}</button>
            
            <button class="badButton">{{values.bottomTitle}}</button>
        </div>

        <div class="sky-holder">
            <div class="cloudy">
                <div class="cloud-left floater-left">
                    <svg id="Layer_1" x="0px" y="0px"
                        viewBox="0 0 295 148" style="enable-background:new 0 0 295 148;" xml:space="preserve">
                        <path class="cloud-left" d="M293.6,144.7l-31.3-4.9c-4-0.6-6.7-4.6-5.7-8.4c0.8-3,1-6.2,0.5-9.5c-1.4-9.3-8.8-16.9-18.1-18.6
                        c-3.1-0.6-6-0.5-8.8,0.1c1-4.4,1.6-8.9,1.6-13.6c0-32.2-26.1-58.3-58.3-58.3c-0.8,0-1.7,0-2.5,0.1C157.6,12.4,135.5,0,110.5,0
                        C72.9,0,42,27.9,37.1,64.2C15.9,66.6-0.5,85,0,107c0.6,23,20.1,41,43,41h127.8v-0.1c0.9,0,1.7,0.1,2.6,0.1c0.3,0,0.6,0,1,0h118.8
                        C295.4,148,295.6,145,293.6,144.7z"/>
                    </svg>
                </div>
                <div class="cloud-right floater-right">
                    <svg id="Layer_1" x="0px" y="0px"
                        viewBox="0 0 295 148" style="enable-background:new 0 0 295 148;" xml:space="preserve">
                    <path class="cloud-right" d="M1.4,144.7l31.3-4.9c4-0.6,6.7-4.6,5.7-8.4c-0.8-3-1-6.2-0.5-9.5c1.4-9.3,8.8-16.9,18.1-18.6
                        c3.1-0.6,6-0.5,8.8,0.1c-1-4.4-1.6-8.9-1.6-13.6c0-32.2,26.1-58.3,58.3-58.3c0.8,0,1.7,0,2.5,0.1C137.4,12.4,159.5,0,184.5,0
                        c37.5,0,68.5,27.9,73.3,64.2C279.1,66.6,295.5,85,295,107c-0.6,23-20.1,41-43,41H124.1v-0.1c-0.9,0-1.7,0.1-2.6,0.1
                        c-0.3,0-0.6,0-1,0H1.7C-0.4,148-0.6,145,1.4,144.7z"/>
                    </svg>
                </div>
            </div>
            <div class="sun-holder">
                <svg id="Layer_1" x="0px" y="0px"
                    viewBox="0 0 472 472" style="enable-background:new 0 0 472 472;" xml:space="preserve">
                <g class="sun-group">
                    <circle class="rays" cx="236" cy="236" r="236"/>
                    <circle class="rays" cx="236" cy="236" r="193.3"/>
                    <circle class="rays" cx="236" cy="236" r="157.8"/>
                    <circle class="sun" cx="236" cy="236" r="123.7"/>
                </g>
                </svg>
            </div>
        </div>


        <div class="bubbles-holder">
            <svg id="Layer_1" x="0px" y="0px"
                viewBox="0 0 906 612" style="enable-background:new 0 0 906 612;">
                <circle class="bubbles bubble3 multiplier" cx="847" cy="521" r="11"/>
                <circle class="bubbles bubble multiplier" cx="786" cy="102" r="36"/>
                <circle class="bubbles bubble2 multiplier" cx="858" cy="153" r="15"/>
                <circle class="bubbles bubble2 multiplier" cx="74" cy="452" r="15"/>
                <circle class="bubbles bubble3 multiplier" cx="15" cy="180" r="15"/>
                <circle class="bubbles bubble multiplier" cx="718.5" cy="596.5" r="15.5"/>
                <circle class="bubbles bubble3 multiplier" cx="895.5" cy="10.5" r="10.5"/>
                <circle class="bubbles bubble multiplier" cx="113.5" cy="91.5" r="9.5"/>
                <circle class="bubbles bubble2 multiplier" cx="189" cy="599" r="13"/>
                <circle class="bubbles bubble multiplier" cx="152" cy="144" r="9"/>
            </svg>
        </div>

        

        <div class="flower-holder multiplier">
            <div class="instructions" :class="{hidden:!instruction}">
                Touch & Drag Up
                <div class="description">THE FLOWER BELOW</div>
            </div>
            <vue-draggable-resizable id="dragger" :w="126" :h="126" :y="1092" v-on:dragging="onDrag" :parent="true" :resizable="false" >
                <div class="head-holder multiplier">
                    <svg viewBox="0 0 287.12 287.17">
                        <g class="cls-1">
                            <g id="Layer_1" data-name="Layer 1">
                                <g class="multiplier petals1">
                                    <path class="flower-petals" d="M157.17,16.81l-7.86-9.25a8.72,8.72,0,0,0-13.41.14l-7.48,9.16A8.74,8.74,0,0,1,117,18.74l-10-6.22A8.73,8.73,0,0,0,94.3,16.77L90.07,27.71A8.73,8.73,0,0,1,79.81,33l-11.4-2.85a8.73,8.73,0,0,0-10.83,8l-.67,11.73a8.71,8.71,0,0,1-8.12,8.21l-11.71.8a8.72,8.72,0,0,0-7.85,10.92l3,11.36A8.73,8.73,0,0,1,27,91.48L16.13,95.87A8.74,8.74,0,0,0,12,108.69l6.35,9.87A8.74,8.74,0,0,1,16.64,130l-9,7.51A8.74,8.74,0,0,0,7.68,151l9.08,7.45a8.72,8.72,0,0,1,1.85,11.39l-6.25,9.95a8.74,8.74,0,0,0,4.22,12.78l10.93,4.26a8.73,8.73,0,0,1,5.29,10.27l-2.87,11.39a8.73,8.73,0,0,0,7.94,10.85l11.73.7a8.74,8.74,0,0,1,8.19,8.15l.76,11.71a8.73,8.73,0,0,0,10.91,7.88l11.36-3A8.72,8.72,0,0,1,91.12,260l4.4,11a8.72,8.72,0,0,0,12.74,4.15l10.33-6.47a8.71,8.71,0,0,1,11.34,1.8l7.56,9.07a8.73,8.73,0,0,0,13.45-.05l7.49-9.11a8.73,8.73,0,0,1,11.38-1.86l10,6.27a8.73,8.73,0,0,0,12.76-4.23l4.29-11a8.73,8.73,0,0,1,10.25-5.3l11.45,2.87a8.73,8.73,0,0,0,10.84-7.95l.69-11.78a8.74,8.74,0,0,1,8.13-8.2l11.76-.79a8.74,8.74,0,0,0,7.86-10.92l-3-11.41A8.73,8.73,0,0,1,260,195.8L271,191.38a8.73,8.73,0,0,0,4.08-12.81l-6.37-9.92a8.75,8.75,0,0,1,1.75-11.42l9.05-7.56a8.72,8.72,0,0,0-.05-13.44l-9.12-7.49a8.73,8.73,0,0,1-1.86-11.38l6.26-10a8.73,8.73,0,0,0-4.22-12.77l-11-4.28a8.73,8.73,0,0,1-5.29-10.26L257.1,68.6a8.74,8.74,0,0,0-8-10.83l-11.78-.7A8.72,8.72,0,0,1,229.17,49l-.8-11.77a8.73,8.73,0,0,0-10.91-7.85l-11.42,3a8.74,8.74,0,0,1-10.3-5.19l-4.41-10.94a8.73,8.73,0,0,0-12.81-4.09l-10,6.41A8.75,8.75,0,0,1,157.17,16.81Z"/>
                                </g>
                                <g class="multiplier petals2">
                                    <path class="flower-petals" d="M206,66.47l0-.39A18.75,18.75,0,0,0,180.63,51.3l-.09,0A18.76,18.76,0,0,1,159,45.42l0-.05a18.75,18.75,0,0,0-29.37-.2l0,0a18.74,18.74,0,0,1-21.65,5.62h0A18.75,18.75,0,0,0,82.3,65.33h0A18.75,18.75,0,0,1,66.34,81h0a18.74,18.74,0,0,0-14.92,25.32h0a18.74,18.74,0,0,1-6,21.55l0,0a18.75,18.75,0,0,0-.28,29.37l0,0A18.76,18.76,0,0,1,50.73,179l0,.09a18.75,18.75,0,0,0,14.37,25.6l.38.06A18.73,18.73,0,0,1,81,220.7l0,.17a18.74,18.74,0,0,0,25.32,14.91l.09,0A18.75,18.75,0,0,1,128,241.69l.09.12a18.75,18.75,0,0,0,29.36.24l.09-.12a18.76,18.76,0,0,1,21.63-5.59l.09,0a18.74,18.74,0,0,0,25.56-14.49l0-.09a18.74,18.74,0,0,1,15.94-15.68h.09a18.75,18.75,0,0,0,14.91-25.32l0-.1a18.74,18.74,0,0,1,6-21.53l.12-.09a18.75,18.75,0,0,0,.24-29.36l-.12-.09A18.75,18.75,0,0,1,236.33,108l0-.1a18.75,18.75,0,0,0-14.49-25.56l-.17,0A18.76,18.76,0,0,1,206,66.47Z"/>
                                </g>
                                <path class="flower-hotzone" d="M143.56,70.05h-.2a73.56,73.56,0,0,0,0,147.11h.2a73.56,73.56,0,0,0,0-147.11Z"/>
                            </g>
                        </g>
                    </svg>
                </div>
            </vue-draggable-resizable>
            <div class="flower-stick">
                <div class="stem-holder">
                    <svg viewBox="0 0 171.24 1942.86">
                        <g id="stem-outer" data-name="stem-outer">
                            <g id="stem-inner" data-name="stem-inner">
                            <path class="stem" d="M61.41,1939.71h-34A24.21,24.21,0,0,1,3.15,1915.5h0a24.2,24.2,0,0,1,24.21-24.2H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.21,24.21,0,0,1-24.21-24.2h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.2,24.2,0,0,1-24.21-24.2h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.2,24.2,0,0,0-24.21-24.2H27.36A24.21,24.21,0,0,1,3.15,1625h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.2h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.21,24.21,0,0,1-24.21-24.21h0A24.21,24.21,0,0,1,27.36,1504H143.88a24.2,24.2,0,0,0,24.21-24.2h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.21,24.21,0,0,1-24.21-24.21h0a24.2,24.2,0,0,1,24.21-24.2H143.88A24.21,24.21,0,0,0,168.09,1383h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.21,24.21,0,0,1-24.21-24.2h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.2,24.2,0,0,1-24.21-24.2h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.2,24.2,0,0,0-24.21-24.2H27.36a24.21,24.21,0,0,1-24.21-24.21h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.2h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.21,24.21,0,0,1-24.21-24.21h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.2,24.2,0,0,0,24.21-24.2h0a24.21,24.21,0,0,0-24.21-24.21H27.36A24.21,24.21,0,0,1,3.15,947.22h0A24.2,24.2,0,0,1,27.36,923H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.21,24.21,0,0,0-24.21-24.21H27.36A24.21,24.21,0,0,1,3.15,850.4h0a24.21,24.21,0,0,1,24.21-24.21H143.88A24.21,24.21,0,0,0,168.09,802h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.2,24.2,0,0,1-24.21-24.2h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.21h0A24.2,24.2,0,0,0,143.88,681H27.36A24.21,24.21,0,0,1,3.15,656.74h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.2h0a24.21,24.21,0,0,0-24.21-24.21H27.36A24.21,24.21,0,0,1,3.15,559.91h0A24.21,24.21,0,0,1,27.36,535.7H143.88a24.2,24.2,0,0,0,24.21-24.2h0a24.21,24.21,0,0,0-24.21-24.21H27.36A24.21,24.21,0,0,1,3.15,463.08h0a24.2,24.2,0,0,1,24.21-24.2H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.21,24.21,0,0,1-24.21-24.2h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.21h0a24.21,24.21,0,0,0-24.21-24.21H27.36a24.2,24.2,0,0,1-24.21-24.2h0a24.21,24.21,0,0,1,24.21-24.21H143.88A24.21,24.21,0,0,0,168.09,221h0a24.2,24.2,0,0,0-24.21-24.2H27.36A24.21,24.21,0,0,1,3.15,172.6h0a24.21,24.21,0,0,1,24.21-24.21H143.88a24.21,24.21,0,0,0,24.21-24.2h0A24.21,24.21,0,0,0,143.88,100H27.36A24.21,24.21,0,0,1,3.15,75.77h0A24.21,24.21,0,0,1,27.36,51.56H143.88a24.2,24.2,0,0,0,24.21-24.2h0A24.21,24.21,0,0,0,143.88,3.15"/>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="stembottom-holder">
                    <svg viewBox="0 0 27.36 130.02">
                        <g id="stembottom-outer" data-name="stembottom-outer">
                            <g id="stembottom-inner" data-name="stembottom-inner">
                            <path class="stembottom" d="M24.21,130V27.36A24.21,24.21,0,0,0,0,3.15"/>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
            <div class="leaf-holder">
                <svg viewBox="0 0 116.03 80.7">
                    <g class="cls-1">
                        <g id="Layer_1" data-name="Layer 1">
                            <g>
                                <rect class="leaf-border" width="116.03" height="80.7"/>
                                <g>
                                <path class="leaves" d="M108.76.1C92.24,3,54.73,12.43,27.35,39.81,14.84,52.32,6.1,66.93,0,80.7H35.4L113.94,1.56A6.14,6.14,0,0,0,108.76.1Z"/>
                                <path class="leaves" d="M113.94,1.56,35.4,80.7H83.49c21.83-26.28,29.78-58.46,32.45-73.43A6.15,6.15,0,0,0,113.94,1.56Z"/>
                                <path class="leaves" d="M113.94,1.56,35.4,80.7H83.49c21.83-26.28,29.78-58.46,32.45-73.43A6.15,6.15,0,0,0,113.94,1.56Z"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
    name: 'EnergySlider',
    props: ['value', 'content'],
    mixins: [],
    data() {
        return {
            trackHeight: 524,
            good: false,
            bad: false,
            instruction: true,
            values: {
                topTitle: this.content[0],
                bottomTitle: this.content[1], 
                position: null,
            }
        }
    },

    components: {
        VueDraggableResizable
    },
    ready() {
        
    },
    methods: {
        updateSelection: function () {
            this.$emit('input', this.values.position);
        },
        constrain(n, low, high) {
            return Math.max(Math.min(n, high), low);
        },
        map(n, start1, stop1, start2, stop2, withinBounds = true) {
            var newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
            if (!withinBounds) {
                return newval;
            }
            if (start2 < stop2) {
                return this.constrain(newval, start2, stop2);
            } 
            else {
                return this.constrain(newval, stop2, start2);
            }
        },
        onDrag(x, y) {
            let pct = this.map(y, 1092, 0, 0.0, 1.0);
            if (pct >= .65) {
                this.good = true
            } else {
                this.good = false
            }
            if (pct <= .3) {
                this.bad = true
            } else {
                this.bad = false
                
            }
            if (pct <= .2) {
                this.instruction = true
            } else {
                this.instruction = false
            }
            let path = document.querySelector('.stem');
            let dashMax = path.getTotalLength();
            // update Vals
            let val = parseInt(Math.round(pct*4)-2)
            if (this.values.position != val) this.values.position = val
            let amt = 1-pct
            amt = this.map(amt, 0, 1, .153, .96);
            let dash = dashMax * amt;            
            $(".stem").css("stroke-dashoffset", dash)
            $(".flower-petals").css("transform",`rotate(${y/5}deg)`)
        }
    },

    computed: {
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {

        this.$nextTick(() => {
            let path = document.querySelector('.stem');
            let dashMax = path.getTotalLength();
            let dash = dashMax * .96;
            $(".stem").css("stroke-dashoffset", dash)

            $(".head-holder").on('touchend mouseup', (e) => {
                this.drag.start()
                let timeout = setTimeout(() => {
                    this.updateSelection()
                }, 1000)
            })
        })
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";

.energySliderContainer {
    display:flex;
    flex-direction:column;
    align-items:center;
    align-content:center;
    justify-items:center;
    justify-content:center;
    background:#0BBCC7;
    margin:0px auto;
    overflow: hidden;

    .cloud-left{fill:#ABEBEE;}
    .cloud-right{fill:#ABEBEE;}
    .sun-group{opacity:0.7;}
    .rays{opacity:0.12;fill:#CDF9FC;enable-background:new;}
    .sun{fill:#EFFEFF;}
    .bubbles{fill:#008B9B;}
    .flower-petals {
        fill: #008B9B;
    }
    .flower-hotzone {
        fill: #e0ddcd;
        mix-blend-mode: screen;
    }
    .stem {
        fill: none;
        stroke: #008B9B;
        stroke-miterlimit: 10;
        stroke-width: 6.3px;
    }
    .stembottom {
        fill: none;
        stroke: #008B9B;
        stroke-miterlimit: 10;
        stroke-width: 6.3px;
    }
    .cls-1 {
        isolation: isolate;
    }
    .leaf-border {
        fill: none;
    }
    .leaves {
        fill: #008B9B;
        mix-blend-mode: multiply;
    }
    &.good {
        .goodButton {
            background-color: $color-white;
            color: $color-blue;
        }
        .cloudy {
            opacity: 1;
        }
        .sun {
            transform: scale(1);
        }
        .rays {
            transform: scale(1);
        }
    }
    &.bad {
        .badButton {
            background-color: $color-white;
            color: $color-blue;
        }
        .bubbles-holder {
            opacity: 1;
        }
        .leaf-holder {
            transform: rotate(20deg);
        }
    }

    .bubbles-holder {
        position: absolute;
        width: 85vw;
        mix-blend-mode: multiply;
        height: auto;
        z-index: 7;
        bottom: 10vh;
        opacity:0;
        transition:opacity .5s ease;
        pointer-events:none;
    }
    .draggable {
        z-index: 5;
    }

    .sky-holder {
        position: absolute;
        width: 100%;
        // background: red;
        mix-blend-mode: multiply;
        height: 50vh;
        z-index: 7;
        top: 10vh;
        opacity:1;
        transition:opacity .5s ease;
        pointer-events:none;
    }

    .sun-holder {
        position: absolute;
        top: -40vw;
        right: -20vw;
        width: 60vw;
    }

    .cloudy {
        position: absolute;
        width:100%;
        height: 50vh;
        display:flex;
        flex-direction:row;
        justify-items:space-between;
        justify-content:space-between;
        top:0px;
        opacity:0;
        transition:opacity .5s ease;
        pointer-events:none;
    } 

    .cloud-left {
        width: 50vw;
        left:-5rem;
        position:absolute;
        top:18vh;
    }

    .cloud-right {
        width: 60vw;
        right:-2rem;
        position:absolute;
        top:8vh;
    }

    .sun, .rays {
        transform:scale(0);
        transition:all .5s cubic-bezier(0.77, 0, 0.175, 1);
        transform-origin:center center;
        transform-box: fill-box;
    }

    @keyframes bubble {
        0% {
            opacity:0;
            transform:translateY(10rem);
        }
            20% {
            opacity:0.5;
        }
        80% {
            opacity:0.5;
            transform:translateY(-4rem);
        }
        100% {
            opacity:0;
            transform:translateY(-6rem);
        }
    }

    .bubble {
        animation-name: bubble;
        animation-duration: 6s; 
        animation-timing-function: linear; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }
    .bubble2 {
        animation-name: bubble;
        animation-duration: 6s; 
        animation-timing-function: linear; 
        animation-delay: 1s;
        animation-direction: forwards;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }
    .bubble3 {
        animation-name: bubble;
        animation-duration: 4s; 
        animation-timing-function: linear; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }
    @keyframes float-right {
        0% {
            opacity:0;
            transform:translateX(10rem);
        }
        20% {
            opacity:0.5;
        }
        80% {
            opacity:0.5;
            transform:translateX(-14rem);
        }
        100% {
            opacity:0;
            transform:translateX(-18rem);
        }
    }
    @keyframes float-left {
        0% {
            opacity:0;
            transform:translateX(0rem);
        }
        20% {
            opacity:0.5;
        }
        80% {
            opacity:0.5;
            transform:translateX(12rem);
        }
        100% {
            opacity:0;
            transform:translateX(18rem);
        }
    }
    .floater-right {
        animation-name: float-right;
        animation-duration: 14s; 
        animation-timing-function: linear; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }
    .floater-left {
        animation-name: float-left;
        animation-duration: 12s; 
        animation-timing-function: linear; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }
    .flower-holder {
        position: absolute;
        width: 2vw;
        top: 57vw;
        left: 50vw;
        bottom: 8vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;
        justify-items: center;
        justify-content: center;
    }
    .instructions {
        position: relative;
        z-index: -300000;
        width: 50vw;
        margin-top: 56vw;
        text-align: center;
        font-size: 5vw;
        color: $color-midGreen;
        transition: opacity .5s ease;
        .description {
            margin-top: 1vw;
            font-family: "Walsheim";
            font-size: 2.2vw;
            letter-spacing: .2vw;
        }
        &.hidden {
            opacity: 0;
        }
    }
    .button-holder {
        width: 50vw;
        height: 64vw;
        position: absolute;
        top: 42vh;
        flex-direction: column;
        align-items: center;
        align-content: center;
        justify-items: space-between;
        justify-content: space-between;
        display: flex;
        z-index: 1;
        pointer-events:none;
        
    }
    button {
        width: 50vw;
        height: 10vw;
        font-size: 1.4rem;
        padding: .7rem;
        border-radius: 18rem;
        background: rgba($color-midGreen, .8);
        color:$color-white;
        font-size: 3.5vw;
        font-family: inherit;
        line-height: 8.5vw;
        border:0px;
        transition:all .5s ease;
    }

    .head-holder {
        position: absolute;
        width: 30vw;
        height: 30vw;
        margin-left: -15vw;
        bottom: 0;
        z-index: 5000000;
        svg {
            pointer-events: none;
        }
    }

    .leaf-holder {
        position: absolute;
        bottom: -8.5vw;
        width: 8vw;
        margin-left: 3vw;
        transition: all .5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        mix-blend-mode: multiply;
        transform-origin: bottom left;
        transform-box: view-box;
    }

    .multiplier {
        mix-blend-mode: multiply;
    }

    .flower-stick {
        width: 10vw;
        height: 150vw;
        margin-bottom: -10vw;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: flex-end;
        justify-items: center;
        flex-direction: column;
        position: relative;
        transform: translate(-1vw, 0vw);
    }

    .stemtop-holder {
        position: absolute;
        height: 1.2rem;
        width: 5rem;
        bottom: 61px;
        margin-left: 11px;
    }

    .stem-holder {
        position: absolute;
        height: 60rem;
        width: 5rem;
        bottom: 21vw;
        transform: scale(1.5);
    }

    .stembottom-holder {
        position: absolute;
        height: 3.45rem;
        width: .8rem;
        margin-left: -8px;
        transform: scale(1.5);
    }

    .stem {
        stroke-dasharray: 7620.89453125;
        stroke-dashoffset: 7620.89453125;
        transition:transform .3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        transform-origin:center center;
        transform-box: fill-box;
    }

    @keyframes spin {
        0% {
            transform:rotate(0deg);
        }
        100% {
            transform:rotate(360deg);
        }
    }

    .flower-petals {
        transform-origin:center center;
        transform:rotate(0deg);
        transform-box: fill-box;
    }

    .petalsForward {
        animation: spin 3s linear 0s infinite forwards forwards running;
    }

    .petalsReverse {
        animation: spin 3s linear 0s infinite reverse forwards running;
    }

}

</style>